import React from "react";
import type { UserStats } from "../UsuariosPageNew";

interface UserStatsStripProps {
    stats: UserStats | null;
}

const UserStatsStrip: React.FC<UserStatsStripProps> = ({ stats }) => {
    return (
        <div className="flex border-b border-gray-200 shrink-0 overflow-x-auto scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-transparent">
            {/* 1. Total usuarios */}
            <div className="flex-1 py-3.5 px-6 border-r border-gray-200 flex items-center gap-3 bg-white min-w-[180px]">
                <div className="w-9 h-9 rounded-lg flex items-center justify-center shrink-0 bg-[#4f6df5]/10">
                    <svg width="18" height="18" fill="none" stroke="#4f6df5" strokeWidth="2" viewBox="0 0 24 24">
                        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                        <circle cx="9" cy="7" r="4" />
                    </svg>
                </div>
                <div>
                    <div className="font-mono text-lg font-bold text-gray-900">{stats ? stats.totalUsers : "-"}</div>
                    <div className="text-[11px] text-gray-500 mt-0.5">Total usuarios</div>
                </div>
            </div>

            {/* 2. Activos hoy */}
            <div className="flex-1 py-3.5 px-6 border-r border-gray-200 flex items-center gap-3 bg-white min-w-[180px]">
                <div className="w-9 h-9 rounded-lg flex items-center justify-center shrink-0 bg-[#10b981]/10">
                    <svg width="18" height="18" fill="none" stroke="#10b981" strokeWidth="2" viewBox="0 0 24 24">
                        <circle cx="12" cy="12" r="10" />
                        <polyline points="12 6 12 12 16 14" />
                    </svg>
                </div>
                <div>
                    <div className="font-mono text-lg font-bold text-[#10b981]">{stats ? stats.activeToday : "-"}</div>
                    <div className="text-[11px] text-gray-500 mt-0.5">Activos hoy</div>
                </div>
            </div>

            {/* 3. Huéspedes */}
            <div className="flex-1 py-3.5 px-6 border-r border-gray-200 flex items-center gap-3 bg-white min-w-[180px]">
                <div className="w-9 h-9 rounded-lg flex items-center justify-center shrink-0 bg-[#0ea5e9]/10">
                    <svg width="18" height="18" fill="none" stroke="#0ea5e9" strokeWidth="2" viewBox="0 0 24 24">
                        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                        <circle cx="12" cy="7" r="4" />
                    </svg>
                </div>
                <div>
                    <div className="font-mono text-lg font-bold text-[#0ea5e9]">{stats ? stats.guests : "-"}</div>
                    <div className="text-[11px] text-gray-500 mt-0.5">Huéspedes</div>
                </div>
            </div>

            {/* 4. Anfitriones */}
            <div className="flex-1 py-3.5 px-6 border-r border-gray-200 flex items-center gap-3 bg-white min-w-[180px]">
                <div className="w-9 h-9 rounded-lg flex items-center justify-center shrink-0 bg-[#8b5cf6]/10">
                    <svg width="18" height="18" fill="none" stroke="#8b5cf6" strokeWidth="2" viewBox="0 0 24 24">
                        <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
                    </svg>
                </div>
                <div>
                    <div className="font-mono text-lg font-bold text-[#8b5cf6]">{stats ? stats.hosts : "-"}</div>
                    <div className="text-[11px] text-gray-500 mt-0.5">Anfitriones</div>
                </div>
            </div>

            {/* 5. Super Anfitriones */}
            <div className="flex-1 py-3.5 px-6 border-r border-gray-200 flex items-center gap-3 bg-white min-w-[180px]">
                <div className="w-9 h-9 rounded-lg flex items-center justify-center shrink-0 bg-[#f59e0b]/10">
                    <svg width="18" height="18" fill="none" stroke="#f59e0b" strokeWidth="2" viewBox="0 0 24 24">
                        <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                    </svg>
                </div>
                <div>
                    <div className="font-mono text-lg font-bold text-[#f59e0b]">{stats ? stats.superHosts : "-"}</div>
                    <div className="text-[11px] text-gray-500 mt-0.5">Super Anfitriones</div>
                </div>
            </div>

            {/* 6. Suspendidos */}
            <div className="flex-1 py-3.5 px-6 flex items-center gap-3 bg-white min-w-[180px]">
                <div className="w-9 h-9 rounded-lg flex items-center justify-center shrink-0 bg-[#ef4444]/10">
                    <svg width="18" height="18" fill="none" stroke="#ef4444" strokeWidth="2" viewBox="0 0 24 24">
                        <circle cx="12" cy="12" r="10" />
                        <line x1="4.93" y1="4.93" x2="19.07" y2="19.07" />
                    </svg>
                </div>
                <div>
                    <div className="font-mono text-lg font-bold text-[#ef4444]">{stats ? stats.suspendedUsers : "-"}</div>
                    <div className="text-[11px] text-gray-500 mt-0.5">Suspendidos</div>
                </div>
            </div>
        </div>
    );
};

export default UserStatsStrip;